import React from 'react'
import { SUCCESSICON } from '../../../utills/image-constant';
import { useNavigate } from 'react-router-dom';
import { USERROUTES } from '../../routes/url-constant';

const CompleteTest = () => {
    const navigation = useNavigate();
    return (
        <>

            <div className='d-flex flex-column justify-content-center align-items-center'>
                <img className='mt-5' src={SUCCESSICON} alt='' />
                <h2 className='mt-2 fw-5'>Your Test has been completed...</h2>
                <p>Scorecard generated after the admin has validated the test</p>
                <button type="button" className="compltebtn textfont14 mt-3 px-5 py-2" onClick={() => navigation(USERROUTES.USERPROFILEINTRODUCTION)}>Ok</button>
            </div>
        </>
    )
}

export default CompleteTest;
